export const PURPOSE_SELECT_BEHAVIOR_BLOCK = 'BLOCK';
export const PURPOSE_SELECT_BEHAVIOR_CATEGORY = 'CATEGORY';
